if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const variantInputs = document.querySelectorAll('.product-form__input input');
        if (variantInputs.length) {
            variantInputs.forEach(item => {
                item.addEventListener('click', (e) => {
                    const productForm = document.querySelector('[bss-b2b-main-product-form]')
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {event: e,productForm})
                })
            })
        }
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.id === "quickViewWrapper") {
                   document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                }
                if (item.target.id === "ProductGridContainer") {
                   BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                }               
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 3000)
}